// ============================================================================
// lz-collection-tracker.js
// ----------------------------------------------------------------------------
// Tracker "legacy" qui gère les éléments .lz-collection-item sur les pages
// qui n'ont PAS leur propre tracker (rzc-lor, rzc-pkm, rzc-op, rzc-nar).
//
// MIGRÉ vers l'Edge Function `lz-api` (voir assets/lz-api-client.js).
// Plus d'appel direct au SDK Supabase côté client.
//
// Le tracker se désactive automatiquement si un tracker rzc-* est déjà actif
// sur la page (détecté par la présence d'un conteneur #rzc-lor / #rzc-pkm /
// #rzc-op / #rzc-nar) — cela évite les double-écritures qui créaient des rows
// partielles dans Supabase.
// ============================================================================

(function () {
  const RZC_ROOT_IDS = ['rzc-lor', 'rzc-pkm', 'rzc-op', 'rzc-nar'];

  document.addEventListener('DOMContentLoaded', async () => {
    // Racine avec l'email client ajouté par Liquid
    const root = document.querySelector('[data-lz-customer-email]');
    if (!root) return;

    // Si la page a un tracker rzc-* spécifique, on le laisse gérer.
    // Sinon on se retrouvait à double-écrire avec des rows partielles.
    for (const id of RZC_ROOT_IDS) {
      if (document.getElementById(id)) return;
    }

    const customerEmail = (root.getAttribute('data-lz-customer-email') || '').trim().toLowerCase();
    const universe = (root.getAttribute('data-lz-universe') || '').trim().toLowerCase();
    const seriesHandle = root.getAttribute('data-lz-series-handle') || '';

    // Tous les items + boutons "Je possède cette carte"
    const items = document.querySelectorAll('.lz-collection-item');
    if (!items.length) return;

    // Le wrapper lzApi doit être chargé avant (voir layout/theme.liquid).
    if (!window.lzApi) {
      console.warn('[lz-collection-tracker] window.lzApi non disponible — tracking désactivé.');
      return;
    }

    const hasEmail = !!customerEmail && customerEmail !== 'null';

    // =========================================
    // 1) Chargement initial de la collection
    // =========================================
    let ownedSet = new Set();

    if (hasEmail && universe) {
      const loadRes = await window.lzApi.collectionLoad({ email: customerEmail, universe });
      if (loadRes.ok) {
        ownedSet = new Set((loadRes.data && loadRes.data.products) || []);
      } else {
        console.error('[lz-collection-tracker] collection.load failed:', loadRes);
      }
    } else {
      console.warn('[lz-collection-tracker] email ou universe manquant → tracking désactivé (mode visuel uniquement).');
    }

    // =========================================
    // 2) Wiring des boutons "Je possède cette carte"
    //    → fonctionne même sans lzApi/email (mode visuel)
    // =========================================
    items.forEach((item) => {
      const id = String(item.dataset.productId || '');
      const button = item.querySelector('.lz-toggle-owned');
      if (!button || !id) return;

      // État initial depuis Supabase (si dispo)
      const isOwned = ownedSet.has(id);
      updateItemUI(item, button, isOwned);

      button.addEventListener('click', async () => {
        const currentlyOwned = button.dataset.owned === 'true';
        const nextOwned = !currentlyOwned;

        // 2.1 Mise à jour UI optimiste
        updateItemUI(item, button, nextOwned);

        // 2.2 Si pas de contexte utilisable → mode visuel seulement
        if (!hasEmail || !universe) return;

        // 2.3 Persistance via l'Edge Function
        const productTitle = item.dataset.productTitle || '';
        const res = await window.lzApi.toggleProduct({
          email: customerEmail,
          universe,
          productId: id,
          owned: nextOwned,
          seriesHandle,
          productTitle,
        });

        if (!res.ok) {
          console.error('[lz-collection-tracker] toggleProduct failed:', res);
          // Rollback UI en cas d'échec
          updateItemUI(item, button, !nextOwned);
        }
      });
    });
  });
})();

/* ===========================
 * Helpers d'UI
 * =========================== */
function updateItemUI(item, button, owned) {
  if (owned) {
    item.classList.add('lz-owned');
    button.dataset.owned = 'true';
    button.textContent = '✅ Possédée';
  } else {
    item.classList.remove('lz-owned');
    button.dataset.owned = 'false';
    button.textContent = '➕ Ajouter';
  }
}
